<template>
  <div class="fancy-text-block-twentyThree lg-container  pt-30 md-mt-30" id="feature">

    <div class="container">
      <div class="row">
        <div class="col-lg-6 " data-aos="fade-right">
          <div class="text-wrapper ps-xl-5">
            <div class="cl-text"> <span></span></div>
            <div class="title-style-twelve">
              <h2>RoboQuark: The Full Robotics Learning Solution</h2>
              <p class="mt-35 mb-60 md-mb-40">
                RoboQuark helps learners at any level explore and grow in robotics—whether you're just getting started
                or looking to take your skills further. From learning and simulation to coding and real robot control,
                everything is built to be hands-on, flexible, and easy to follow. With AI-powered guidance, cloud-based
                tools, and hardware you can build with, RoboQuark makes learning robotics simple, practical, and fun—for
                individuals, classrooms, and teams.
              </p>
            </div>
            <a href="/register" class="theme-btn-eight">Get Start </a>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-left">
          <div class="img-container position-relative md-mt-60">
            <img src="../../assets/images/assets/Robot.png" alt="" class="main-screen"
              style="max-width: 80% !important;" />


          </div>
        </div>
      </div>
    </div>

    <div class="container ">
      <div class="row justify-content-between">
        <div v-for="item in textBlockData" :key="item.id" class="col-xl-3 col-md-4" data-aos="fade-up"
          :data-aos-delay="item.delay">
          <div class="block-style-twentyEight text-center">
            <div class="icon d-flex justify-content-center align-items-end">
              <img :src="item.icon" alt="" />
            </div>
            <h4>{{ item.title }}</h4>
          </div>
          <!-- /.block-style-twentyEight -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FancyTextBlock",
  data() {
    return {
      textBlockData: [
        {
          id: 1,
          icon: require(`@/assets/images/icon/149.svg`),
          title: "Practical",
        },
        {
          id: 2,
          icon: require(`@/assets/images/icon/150.svg`),
          title: "Simple to use",

          delay: "100",
        },
        {
          id: 3,
          icon: require(`@/assets/images/icon/151.svg`),
          title: "Save time & Effort",
          delay: "200",
        },
      ],
    };
  },
};
</script>
